import HomeCard from "../cards/Home-card.tsx";
import { content } from "../../data.tsx";

const HomeCardSection = () => {
  return (
    <div className="w-[90%] flex flex-col justify-center items-center py-10">
      <div className="lg:w-[60%] text-center flex flex-col justify-center items-center gap-3">
        <span className="text-blue text-xs font-medium tracking-widest uppercase">Use cases</span>
        <h3 className="font-display text-2xl lg:text-4xl font-semibold tracking-tight text-lightBlack">
          Popular <span className="text-blue">Use Cases</span>
        </h3>
        <p className="text-gray-500 text-base leading-relaxed max-w-2xl mt-1">
          Explore how Coach AI helps professionals make better decisions and unlock new growth.
        </p>
      </div>

      <div className="flex lg:flex-row flex-col w-full gap-6 justify-around items-stretch mt-2">
        {content?.cards?.map((item, index) => (
          <HomeCard
            key={index}
            imgSrc={item.imgUrl}
            headingContent={item.head}
            paraContent={item.content}
          />
        ))}
      </div>
    </div>
  );
};

export default HomeCardSection;
